import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import type { InfoType } from '~/modules/artist-roster/components/ArtistContactInfo/types';
import type { ArtistEntityType } from '~/modules/artist-roster/types';

interface ContactInfoHeaderProps {
  isLoading: boolean;
  infoType: InfoType;
  onInfoTypeButtonClick: (infoType: InfoType) => void;
  entityType: ArtistEntityType;
}

export function ContactInfoHeader({
  isLoading,
  infoType,
  onInfoTypeButtonClick,
  entityType,
}: ContactInfoHeaderProps) {
  const { t } = useTranslation('roster');

  return (
    <div className="mb-md flex basis-full items-center justify-start gap-md pb-xs bg-transparent text-default">
      {/* Artist info */}
      {['Crossover', 'Artist'].includes(entityType) ? (
        <button
          disabled={isLoading}
          className={cn({
            'underline decoration-2 underline-offset-8 decoration-primary-default hover:underline':
              infoType === 'artist' && entityType === 'Crossover',
            'cursor-default': infoType === 'artist',
          })}
          onClick={() => onInfoTypeButtonClick('artist')}
        >
          {t('contactInfo.artistInfo')}
        </button>
      ) : null}
      {/* Songwriter info */}
      {['Crossover', 'Songwriter'].includes(entityType) ? (
        <button
          disabled={isLoading}
          className={cn({
            'underline decoration-2 underline-offset-8 decoration-primary-default hover:underline':
              infoType === 'songwriter' && entityType === 'Crossover',
            'cursor-default': infoType === 'songwriter',
          })}
          onClick={() => onInfoTypeButtonClick('songwriter')}
        >
          {t('contactInfo.songwriterInfo')}
        </button>
      ) : null}
    </div>
  );
}

ContactInfoHeader.displayName = 'ContactInfoHeader';
